export default __webpack_public_path__ + "static/media/serpr-logo-2.873eb4ea.svg";